/* eslint-disable react/no-deprecated */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import InputAdornment from '@material-ui/core/InputAdornment';
import { styles } from './FidelityProgram.styles';
import Input from '../Input';
import { handleChange } from './FidelityProgram.services';
function FidelityProgram({ classes, setStateObj, stateObj, validationMessage, setValidationMessage }) {
  return (
    <>
      <div elevation={0} className={`${classes.paper} ${!stateObj.enabledCashBack && classes.disabledStyle}`}>
        <>
          <p className={classes.designText}>Montant de la fidélité</p>
          <Input
            margin='dense'
            id='cashBackPointsPerEuro'
            variant='outlined'
            value={stateObj.cashBackPointsPerEuro}
            className={classes.inputStyle}
            placeholder='Ex:10'
            error={validationMessage.cashBackPointsPerEuro && validationMessage.cashBackPointsPerEuro.text === 'is-invalid'}
            onChange={e => (
              setStateObj({ cashBackPointsPerEuro: e.target.value }),
              handleChange(e, validationMessage, setValidationMessage)
            )}
            onFocus={e => handleChange(e, validationMessage, setValidationMessage)}
            onBlur={e => handleChange(e, validationMessage, setValidationMessage)}
            InputProps={{
              endAdornment: <InputAdornment position='end'>€</InputAdornment>
            }}
          />
          <p className={classes.designText}>Pour combien d'euros dépensés</p>
          <Input
            margin='dense'
            id='limit'
            variant='outlined'
            value={stateObj.limit}
            onChange={e => (
              setStateObj({ limit: e.target.value }),
              handleChange(e, validationMessage, setValidationMessage)
            )}
            onFocus={e => handleChange(e, validationMessage, setValidationMessage)}
            onBlur={e => handleChange(e, validationMessage, setValidationMessage)}
            className={classes.inputStyle}
            placeholder='Ex:100'
            error={validationMessage.limit && validationMessage.limit.text === 'is-invalid'}
            InputProps={{
              endAdornment: <InputAdornment position='end'>€</InputAdornment>
            }}
          />
          <p className={classes.designText}>Valeur minimale du panier</p>
          <Input
            margin='dense'
            id='minBasket'
            variant='outlined'
            value={stateObj.minBasket}
            onChange={e => (
              setStateObj({ minBasket: e.target.value < 0 ? 0 : e.target.value })
            )}
            className={classes.inputStyle}
            placeholder='Ex:15'
            InputProps={{
              endAdornment: <InputAdornment position='end'>€</InputAdornment>
            }}
          />
        </>
      </div>
    </>
  );
}



export default (withStyles(styles)(withRouter(FidelityProgram)));
